import { render, staticRenderFns } from "./recommend-htk.vue?vue&type=template&id=22ad0d71&scoped=true"
import script from "./recommend-htk.vue?vue&type=script&lang=js"
export * from "./recommend-htk.vue?vue&type=script&lang=js"
import style0 from "./recommend-htk.vue?vue&type=style&index=0&id=22ad0d71&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ad0d71",
  null
  
)

export default component.exports